import "./courses.css";
import { CourseOfferBadge, OfferPriceTag } from "./CourseOfferBadge";

import beginnerImg from "../../../assets/courses/beginner.jpeg";
import intermediateImg from "../../../assets/courses/intermediate.jpeg";
import professionalImg from "../../../assets/courses/professional.jpeg";
import speakCompleteImg from "../../../assets/courses/speak complete.jpeg";

export const LEVEL_FALLBACK_IMG = {
  BEGINNER: beginnerImg,
  INTERMEDIATE: intermediateImg,
  PROFESSIONAL: professionalImg,
  SPEAK_COMPLETE: speakCompleteImg,
};

export const fmt = (paise) => `₹${(paise / 100).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

const isOfferExpired = (offer) => offer?.endDate && new Date(offer.endDate) < new Date();

export const LEVEL_LABELS = {
  BEGINNER: "Beginner",
  INTERMEDIATE: "Intermediate",
  PROFESSIONAL: "Professional",
  SPEAK_COMPLETE: "Speak Complete",
};

export const PriceTag = ({ course }) => {
  const parts = [];
  if (course.batchModeEnabled && course.priceBatch != null)
    parts.push(`Batch ${fmt(course.priceBatch)}`);
  if (course.personalModeEnabled && course.pricePersonal != null)
    parts.push(`Personal Coaching ${fmt(course.pricePersonal)}`);
  return (
    <span className="cc-card-prices">
      {parts.length ? parts.join(" / ") : "—"}
    </span>
  );
};

export const BatchBadge = ({ totalBatches, hasOpenBatches }) => {
  if (totalBatches === 0 || totalBatches == null) return null;
  if (hasOpenBatches)
    return <span className="cc-level cc-avail-open">✅ Batches Available</span>;
  return <span className="cc-level cc-avail-closed">No Open Batches</span>;
};

const CourseCard = ({ course, onView, onDemo, demoBooked, activeBatchCount, onContinue }) => {
  const hasActiveBatch = activeBatchCount > 0;

  return (
    <div className="cc-card">
      <img
        src={course.thumbnailUrl || LEVEL_FALLBACK_IMG[course.level]}
        alt={course.name}
        className="cc-card-thumb"
      />

      {hasActiveBatch && (
        <div className="cc-card-enrolled-ribbon">
          ▶ {activeBatchCount} Active Batch{activeBatchCount > 1 ? "es" : ""}
        </div>
      )}

      <div className="cc-card-body">
        <div className="cc-card-top">
          <span className={`cc-level cc-level-${course.level}`}>
            {LEVEL_LABELS[course.level] || course.level}
          </span>
          <BatchBadge totalBatches={course.totalBatches} hasOpenBatches={course.hasOpenBatches} />
        </div>

        <h3 className="cc-card-name">{course.name}</h3>
        <p className="cc-card-desc">{course.shortDescription}</p>

        <div className="cc-card-meta">
          <span>📅 {course.totalDays} days</span>
          <span>⏱ {course.sessionDurationMins} min/session</span>
        </div>

        {course.offer && !isOfferExpired(course.offer)
          ? <OfferPriceTag course={course} />
          : <PriceTag course={course} />}
        <CourseOfferBadge offer={course.offer} />
      </div>

      {hasActiveBatch && onContinue && (
        <div style={{ padding: "0 12px 10px" }}>
          <button className="cc-btn-continue-full" onClick={onContinue}>
            ▶ Continue Learning →
          </button>
        </div>
      )}

      <div className="cc-card-footer">
        {demoBooked ? (
          <button className="cc-btn cc-btn-demo-booked" disabled>✓ Demo Booked</button>
        ) : (
          <button className="cc-btn cc-btn-outline" onClick={() => onDemo(course.id)}>
            🎓 Free Demo
          </button>
        )}
        <button className="cc-btn cc-btn-primary" onClick={() => onView(course.id)}>
          View Course →
        </button>
      </div>
    </div>
  );
};

export default CourseCard;
